const getImageUrl = (path: string) => {
    return `https://images.mockat.com${path}`;
};

export default getImageUrl;
